import appConfig from '@nerdwallet/app-config';

export const checkComponentShouldTriggerLegacyImpressions = (
  componentName: string
): boolean => {
  return !appConfig.ANALYTICS?.DISABLE_LEGACY_EVENTS_ON_COMPONENTS?.includes(
    componentName
  );
};
